import { Range, Record } from 'immutable';

export const PageParamsFactory = new Record({
  idx: 0,
  height: 0,
  rotate: 0,
  embdRotate: 0,
  status: null,
});

export function getTransform(x = 0, y = 0) {
  return `translate3d(${x}px, ${y}px, 0)`;
}

export const rumb = ['top', 'right', 'bottom', 'left'];
export const dm = ['width', 'height'];
export const angles = [0, 90, 180, 270];

export function getPropName(prop, rotate) {
  const idx = rotate / 90;
  const r = rumb.indexOf(prop);
  const d = dm.indexOf(prop);
  if (r > -1) return rumb[(r + idx) % rumb.length];
  return dm[(d + idx) % dm.length];
}

export function createRange(...arg) {
  return Range(...arg).toList();
}

export function getPageParams(pageInfo, pageParams, viewPortWidth, scale) {
  /*
  When document has embed rotation pdf.js would still provide pageInfo with height and width
  that doesnt respect embed rotation, though doc will be rendered in a right manner.
  If embeded rotation is 90/270 we must substitude width and height manually.
  Later we will do additional substitution when backend/frontend rotation is applied additionally
   */
  const isEmbedRotated = (pageParams.embdRotate / 90) % 2 === 1;

  const height = Math.abs(pageInfo.view[3] - pageInfo.view[1]);
  const width = Math.abs(pageInfo.view[2] - pageInfo.view[0]);

  const pageProportions = {
    width: isEmbedRotated ? height : width,
    height: isEmbedRotated ? width : height,
  };

  const params = {
    height: (pageProportions.height * viewPortWidth) / pageProportions.width,
    width: (pageProportions.width * viewPortWidth) / pageProportions.height,
  };

  return pageParams
    .set('height', params[getPropName('height', pageParams.rotate)] * scale)
    .set('embdRotate', pageInfo.rotate);
}

export function findIndex(target) {
  return (a, v, i) => {
    if (v === target) return i;
    if (typeof a !== 'undefined') return a;
    return a;
  };
}

export function cancellation(fn) {
  let cancel = false;
  return {
    onCancel() {
      cancel = true;
    },
    execute(...args) {
      if (!cancel) fn(...args);
    },
  };
}
